export const featureFlags = {
  newBomItemDetails: {
    enabled: true,
    description: 'New bom item details page',
  },
  supplierManagement: {
    enabled: true,
    description: 'Supplier management settings page',
  },
  bomFactory: {
    enabled: true,
    description: 'UI will reflect the BoM management module',
  },
  estimationFactory: {
    enabled: true,
    description: 'UI will reflect the Estimation Factory module',
  },
  selfServicePortal: {
    enabled: true,
    description: 'UI will reflect the Self Service Portal module',
  },
  productionTimeRegistration: {
    enabled: true,
    description: 'Virtual Factory => Production Time Registration',
  },
  enableNewMessenger: {
    enabled: true,
    description: 'Replace Intercom with the new Messenger',
    queryParameterValue: 'true',
    persistInSession: false,
  },
}
